import { getScriptTags } from "./getLegalDocument";
import { Logger } from "./logger";

/**
 * 🔹 Extrahiert `src`-Attribute aus `<script>`-Tags.
 */
function extractScriptSrc(scriptTag: string): string | null {
    const match = scriptTag.match(/src=["'](https?:\/\/[^"']+)["']/);
    return match ? match[1] : null;
}

/**
 * 🔹 Lädt ein Skript nur, wenn es noch nicht im DOM vorhanden ist.
 */
function loadScriptOnce(scriptUrl: string): void {
    const alreadyLoaded = document.querySelector(`script[src="${scriptUrl}"]`);
    if (alreadyLoaded) {
        Logger.info("⏩ Script bereits im DOM, übersprungen:", scriptUrl);
        return;
    }

    const scriptTag = document.createElement("script");
    scriptTag.src = scriptUrl;
    scriptTag.async = true;

    scriptTag.onerror = () => {
        Logger.error(`Fehler beim Laden von ${scriptUrl}`);
    };

    document.head.appendChild(scriptTag);
    Logger.info("✅ Tag-Skript geladen:", scriptUrl);
}

/**
 * 🔹 Lädt externe Skripte ohne zusätzliche Blockierung (CMP steuert alles).
 */
export async function loadTrackingScripts(): Promise<void> {
    try {
        const scripts = await getScriptTags();
        if (!scripts) {
            Logger.warn("Keine Skripte gespeichert.");
            return;
        }

        let scriptArray: string[];
        try {
            scriptArray = JSON.parse(scripts);
        } catch {
            scriptArray = scripts
                .split("\n")
                .map(script => script.trim())
                .filter(script => script.length > 0);
        }

        scriptArray.forEach(scriptContent => {
            try {
                const scriptUrl = scriptContent.startsWith("<script")
                    ? extractScriptSrc(scriptContent)
                    : scriptContent;

                if (!scriptUrl) {
                    Logger.warn("⚠️ Keine gültige URL extrahierbar:", scriptContent);
                    return;
                }

                if (!scriptUrl.startsWith("https://")) {
                    Logger.warn("⚠️ Unsichere oder ungültige URL erkannt:", scriptUrl);
                    return;
                }

                // ✅ Nur einfügen, wenn noch nicht vorhanden
                loadScriptOnce(scriptUrl);
            } catch (err) {
                Logger.error("❌ Fehler beim Verarbeiten eines Skripts", { scriptContent, err });
            }
        });

    } catch (error) {
        Logger.error("❌ Fehler beim Laden der Tag-Skripte:", error);
    }
}

/**
 * 🔹 Sofortiger Start (Consent & CMP steuern die Inhalte intern)
 */
loadTrackingScripts();
